import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface NotificationData {
  type: 'success' | 'error' | 'warning';
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject = new Subject<NotificationData>();
  notification$ = this.notificationSubject.asObservable();

  showNotification(notification: NotificationData) {
    this.notificationSubject.next(notification);
  }

  success(message: string) {
    this.showNotification({ type: 'success', message });
  }

  error(message: string) {
    this.showNotification({ type: 'error', message });
  }

  warning(message: string) {
    this.showNotification({ type: 'warning', message });
  }
}
